<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item label="类型">
              <a-select placeholder="请选择类型" v-model="queryParam.dateType">
                  <a-select-option  v-for="item in dateTypeOptions" :value="item.value"  :key="item.value" >{{item.label}}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item label="基地">
              <j-dict-select-tag  ref="baseSelectRef" placeholder="请选择基地"  @chooseFirst="handleBaseChoosedFirst" v-model="queryParam.baseId" :isChooseFirst="true" dictCode="bus_inspection_general_base,base,id,status=1"  >
              </j-dict-select-tag>
            </a-form-item>
          </a-col> 
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item label="部门">
              <j-dict-select-tag placeholder="请选择部门"  v-model="queryParam.departId"  :dictCode="departIdDict"  >
              </j-dict-select-tag>
            </a-form-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item label="巡查类型">
              <a-select placeholder="请选择巡查类型" v-model="queryParam.inspectionType">
                  <a-select-option  value=""  key="all" >全部</a-select-option>
                  <a-select-option  value="inspection"  key="inspection" >常规巡查</a-select-option>
                  <a-select-option  value="safety"  key="safety" >安全巡查</a-select-option>
                  <a-select-option  value="action"  key="action" >行为督查</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :xl="10" :lg="11" :md="12" :sm="24"  style="max-width: 550px;"  >
              <a-form-item label="创建时间">
                <j-date :show-time="true" date-format="YYYY-MM-DD" placeholder="请选择开始时间" class="query-group-cust" v-model="queryParam.startDate"></j-date>
                <span class="query-group-split-cust"></span>
                <j-date :show-time="true" date-format="YYYY-MM-DD" placeholder="请选择结束时间" class="query-group-cust" v-model="queryParam.endDate"></j-date>
              </a-form-item>
            </a-col>
          <!-- <template v-if="toggleSearchStatus">
            
          </template> -->
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
              <a-button type="primary" @click="searchQuery" icon="search">查询</a-button>
              <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">重置</a-button>
              <!-- <a @click="handleToggleSearch" style="margin-left: 8px">
                {{ toggleSearchStatus ? '收起' : '展开' }}
                <a-icon :type="toggleSearchStatus ? 'up' : 'down'"/>
              </a> -->
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <!-- 查询区域-END -->
    
    <!-- 操作按钮区域 -->
    <div class="table-operator">
      <a-button type="primary" icon="download" @click="handleExportXls('巡查汇总表')">导出</a-button>
      <!-- <a-button @click="handleAdd" type="primary" icon="plus">新增</a-button>
      <a-upload name="file" :showUploadList="false" :multiple="false" :headers="tokenHeader" :action="importExcelUrl" @change="handleImportExcel">
        <a-button type="primary" icon="import">导入</a-button>
      </a-upload> -->
      <!-- <a-dropdown v-if="selectedRowKeys.length > 0">
        <a-menu slot="overlay">
          <a-menu-item key="1" @click="batchDel"><a-icon type="delete"/>删除</a-menu-item>
        </a-menu>
        <a-button style="margin-left: 8px"> 批量操作 <a-icon type="down" /></a-button>
      </a-dropdown> -->
    </div>

    <!-- table区域-begin -->
    <div>
      <!-- <div class="ant-alert ant-alert-info" style="margin-bottom: 16px;">
        <i class="anticon anticon-info-circle ant-alert-icon"></i> 已选择 <a style="font-weight: 600">{{ selectedRowKeys.length }}</a>项
        <a style="margin-left: 24px" @click="onClearSelected">清空</a>
      </div> -->

      <a-table
        ref="table"
        size="middle"
        bordered
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"        
        @change="handleTableChange">
        <template slot="htmlSlot" slot-scope="text">
          <div v-html="text"></div>
        </template>
        <template slot="imgSlot" slot-scope="text">
          <span v-if="!text" style="font-size: 12px;font-style: italic;">无此图片</span>
          <img v-else :src="getImgView(text)" height="25px" alt="图片不存在" style="max-width:80px;font-size: 12px;font-style: italic;"/>
        </template>
        <template slot="fileSlot" slot-scope="text">
          <span v-if="!text" style="font-size: 12px;font-style: italic;">无此文件</span>
          <a-button
            v-else
            :ghost="true"
            type="primary"
            icon="download"
            size="small"
            @click="uploadFile(text)">
            下载
          </a-button>
        </template>
      </a-table>
    </div>
  </a-card>
</template>

<script>

  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import { postAction } from '@/api/manage'
  import JDate from '@/components/jeecg/JDate.vue'


  export default {
    name: "TableInspectionSummary",
    mixins:[JeecgListMixin],
    components: {
         JDate
    },
    data () {
      return {
        dateTypeOptions:[{
            value:"week",
            label:"周"
        },{
            value:"month",
            label:"月"
        },{
            value:"quarter",
            label:"季度"
        },{
            value:"year",
            label:"年"
        }],
        description: '金牌石信息管理页面',
        // 表头
        columns: [
          {
            title: '#',
            dataIndex: '',
            key:'rowIndex',
            width:60,
            align:"center",
            customRender:function (t,r,index) {
              return parseInt(index)+1;
            }
          },
          {
            key:"inspectionDepart",
            title:'部门',
            align:"center",
            dataIndex: 'inspectionDepart'
          },
          {
            key:"inspectionWorkshop",
            title:'课室',
            align:"center",
            dataIndex: 'inspectionWorkshop'
          },
          {
            key:"totalNum",
            title:'巡查总数',
            align:"center",
            dataIndex: 'totalNum'
          },
          {
            key:"questionNum",
            title:'巡查异常次数',
            align:"center",
            dataIndex: 'questionNum'
          },
          {
            key:"questionRate",
            title:'巡查异常率',
            align:"center",
            dataIndex: 'questionRate',
            customRender(text){
              return text+"%"
            },
          },
          {
            key:"questionSonNum",
            title:'异常点次数',
            align:"center",
            dataIndex: 'questionSonNum'
          },
          {
            key:"improveSonNum",
            title:'异常点已改善数',
            align:"center",
            dataIndex: 'improveSonNum'
          },
          {
            key:"improveSonRate",
            title:'异常点改善完成率',
            align:"center",
            dataIndex: 'improveSonRate',
            customRender(text){
              return text+"%"
            },
          },
          {
            key:"startDate",
            title:'起始时间',
            align:"center",
            dataIndex: 'startDate'
          },
          {
            key:"endDate",
            title:'结束时间',
            align:"center",
            dataIndex: 'endDate'
          },
        ],
        url: {
          list: "/general/busInspectionReport/countQuestionImproveRatePage",
          exportXlsUrl:"/general/busInspectionReport/countQuestionImproveRateExportXls"
        },
        departIdDict:"bus_inspection_general_base_depart,depart,id,status='1'",
        disableMixinCreated:true,
      }
    },
    computed: {
      importExcelUrl: function(){
        return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`;
      }
    },
    methods: {
      loadData (arg) {
        if (!this.url.list) {
            this.$message.error("请设置url.list属性!")
            return
        }
        //加载数据 若传入参数1则加载第一页的内容
        if (arg === 1) {
            this.ipagination.current = 1;
        }
        var params = this.getQueryParams();//查询条件
        params.hasAdmin=true
        this.loading = true;
        postAction(this.url.list, params).then((res) => {
            if (res.success) {
                this.dataSource = res.result.records;
                this.ipagination.total = res.result.total;
                this.pageRefresh ++
            }
            if (res.code === 510) {
                this.$message.warning(res.message)
            }
            this.loading = false;
        })
      },
      handleBaseChoosedFirst(){
        this.$nextTick(()=>{
          this.loadData(1);
        })
      },
      searchReset () {
        let firsterData=this.$refs.baseSelectRef.getCurrentDictOptions()[0]
        this.queryParam = {
          baseId:firsterData?firsterData.value:undefined,
        }
        this.loadData(1);
      },
    },
    watch:{
      "queryParam.baseId":{
        deep:true,
        handler(newValue){
          console.log("newValue")
          console.log(newValue)
          if(newValue){
            this.departIdDict=`bus_inspection_general_base_depart,depart,id,status='1' AND base_id='${newValue}'`
            return
          }
          this.departIdDict="bus_inspection_general_base_depart,depart,id,status='1'"
        }
      }
    }
  }
</script>
<style scoped>
  @import '~@assets/less/common.less';
</style>